import { Controller } from "@hotwired/stimulus"

// Reusable dropdown that renders its menu with `position: fixed` so it escapes
// any `overflow` ancestor (e.g. a scrollable data table) and stacks above
// sibling content. Reuses Bootstrap's `.dropdown-menu` / `.show` styling.
export default class extends Controller {
  static targets = ["toggle", "menu"]
  static values = {
    placement: { type: String, default: "bottom-end" },
    offset: { type: Number, default: 4 }
  }

  connect() {
    this.onDocClick = (e) => { if (!this.element.contains(e.target)) this.close() }
    this.onKeydown = (e) => { if (e.key === "Escape") { this.close(); this.toggleTarget.focus() } }
    this.onReflow = () => this.reposition()
  }

  disconnect() {
    this.close()
  }

  toggle(e) {
    e.preventDefault()
    e.stopPropagation()
    this.isOpen ? this.close() : this.show()
  }

  show() {
    if (this.isOpen) return
    this.isOpen = true
    this.menuTarget.classList.add("show")
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.reposition()
    document.addEventListener("click", this.onDocClick, true)
    document.addEventListener("keydown", this.onKeydown)
    window.addEventListener("resize", this.onReflow)
    window.addEventListener("scroll", this.onReflow, true)
  }

  reposition() {
    const m = this.menuTarget
    const t = this.toggleTarget.getBoundingClientRect()
    Object.assign(m.style, { position: "fixed", margin: "0", right: "auto", bottom: "auto", zIndex: "1080" })
    const r = m.getBoundingClientRect()
    const end = this.placementValue.endsWith("end") || m.classList.contains("dropdown-menu-end")
    const vw = document.documentElement.clientWidth
    const vh = document.documentElement.clientHeight
    let left = end ? t.right - r.width : t.left
    let top = t.bottom + this.offsetValue
    if (top + r.height > vh && t.top - r.height - this.offsetValue > 0) {
      top = t.top - r.height - this.offsetValue
    }
    left = Math.max(8, Math.min(left, vw - r.width - 8))
    m.style.top = `${top}px`
    m.style.left = `${left}px`
  }

  close() {
    if (!this.isOpen) return
    this.isOpen = false
    this.menuTarget.classList.remove("show")
    this.toggleTarget.setAttribute("aria-expanded", "false")
    Object.assign(this.menuTarget.style, { position: "", top: "", left: "", right: "", bottom: "", margin: "", zIndex: "" })
    document.removeEventListener("click", this.onDocClick, true)
    document.removeEventListener("keydown", this.onKeydown)
    window.removeEventListener("resize", this.onReflow)
    window.removeEventListener("scroll", this.onReflow, true)
  }
}
